export default __webpack_public_path__ + "static/rick-826f56a4c9e69006338da948ccadf0b8.jpg";